import React from 'react'
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { baseURL } from '@/utility/api'
import { useNavigate } from 'react-router-dom'



const UserAvatar = ({image}) => {
  const navigate = useNavigate();
  const handleSignOut = () => {
    window.open(`${baseURL}/logout`,"_self")
  }
  
  return (
    <DropdownMenu >
  <DropdownMenuTrigger>
  <Avatar>
    <AvatarImage src={image} />
    <AvatarFallback>CN</AvatarFallback>
  </Avatar>
  </DropdownMenuTrigger>
  <DropdownMenuContent className = "md:mt-5">
  <DropdownMenuLabel>My Account</DropdownMenuLabel>
  <DropdownMenuSeparator />
  <DropdownMenuItem onClick = {()=>{navigate("/my-courses")}}>My Courses</DropdownMenuItem>
  <DropdownMenuItem onClick = {()=>{navigate("/my-sessions")}}>My Sessions</DropdownMenuItem>
  <DropdownMenuItem onClick = {()=>{navigate("/my-resources")}}>My Resources</DropdownMenuItem>
    <DropdownMenuItem onClick = {handleSignOut}>Log Out</DropdownMenuItem>
    
  </DropdownMenuContent>
</DropdownMenu>

    
  
  )
}

export default UserAvatar